import { createSelector } from "@reduxjs/toolkit"

// export const selectedAccessoriesSelector = createSelector<
//   RootState,
//   AccessoriesState["accessories"],
//   AccessoriesState["selectedAccessoriesCodes"],
//   AccessoriesState["accessories"]
// >(
//   (state) => state.accessories.accessories,
//   (state) => state.accessories.selectedAccessoriesCodes,
//   (accessories, selectedAccessoriesCodes) =>
//     accessories.filter((accessory) =>
//       selectedAccessoriesCodes.includes(accessory.details.code)
//     )
// )

export const selectedAccessoriesSelector = createSelector(
  (state) => state.accessories.accessories,
  (state) => state.accessories.selectedAccessoriesCodes,
  (accessories, selectedAccessoriesCodes) =>
    accessories.filter((accessory) =>
      selectedAccessoriesCodes.includes(accessory.details.code)
    )
)
